import { Component, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, filter, lastValueFrom, map, Subject } from 'rxjs';
import { EventService } from '../../../services/event.service';
import { ZoomMtg } from '@zoom/meetingsdk';
import { StatisticsService } from 'src/app/services/statistics.service';
import { genUuid } from 'src/app/utils/uuid';
import { ViewManagerService } from 'src/app/services/views/view-manager.service';
import { publicSiteVisitTracker, SiteVisitTracker } from 'src/app/models/views/sitevisit-tracker';
import { ViewTrackerType } from 'src/app/models/payloads/view-payloads';
import { cookie_domain } from 'src/environments/environment';
import { DateTime } from 'luxon';
import { SiteVisitCookieService } from 'src/app/services/views/site-visit-cookie.service';

@Component({
  selector: 'app-liveevent',
  templateUrl: './liveevent.component.html',
  styleUrl: './liveevent.component.scss'
})
export class LiveeventComponent {

  pingIntervalId: any;
  authEndpoint = 'http://localhost:3000/getSignature'
  // sdkKey = 'RqXMmTy8RDOqsAqK0Y6U_A'
  // meetingNumber = '81260973801'
  // passWord = ''
  role = 0
  zakToken = ''
  userName = ''
  userEmail = ''
  eventData
  viewUid
  registrantToken = 'iFRKETHSv7vkcnShMIRy8Aqh0LzqRFVh9ynCYPmhrBY.DQkAAAATssjVBhZWb3ZHeWo0UlNoS3FyM0N5UUZYTE53AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
  leaveUrl = 'https://app.sicuentame.com'
  evento
  private viewInit$ = new Subject<void>();
  siteVisitTracker: publicSiteVisitTracker | null = null

  private readonly uuidCookieName = 'cuentame_site_visit_uuid';
  private readonly timestampCookieName = 'cuentame_site_visit_timestamp';
  
  constructor(private ngZone: NgZone, private route: ActivatedRoute, private eventService: EventService, private stats: StatisticsService, private viewManager: ViewManagerService, 
     private siteVisitCookie: SiteVisitCookieService){
    this.siteVisitTracker = viewManager.exposePublicTracker(ViewTrackerType.Site)
  }

  ngAfterViewInit(): void {
    // if (this.evento !== undefined) {
    //   this.cargarVista(this.evento);
    // }

    this.viewInit$.next();
  }

  async cargarVista(evento){
    await this.decodeToken()
    let responseEvent =  await lastValueFrom(this.eventService.getWebinarData(evento))
    // let responseAccess =  await lastValueFrom(this.eventService.getWebinarAccess(responseEvent.data.liveEventAttendeeId))
    let responseAccess =  await lastValueFrom(this.eventService.getWebinarAccessV2(responseEvent.data.idLiveEvent))
    this.eventData = responseEvent.data
    const meetingSDKElement = document.getElementById('meetingSDKElement');
    if (!meetingSDKElement) {
      console.error('meetingSDKElement no encontrado');
      return;
    }

    this.viewUid = genUuid();
    document.getElementById('zmmtg-root')!.style.display = 'block !important'

    try {
      await this.sendStartedNew()
    } catch (error) {
      
    }
    
    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.i18n.load('es-ES');
      ZoomMtg.i18n.reload('es-ES');
      ZoomMtg.init({
        leaveUrl: this.leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: (success: any) => {
          console.log(success)
          ZoomMtg.join({
            signature: responseAccess.data.signature,
            meetingNumber: responseAccess.data.zoomMeetingId,
            passWord: '',
            userName: this.userName,
            userEmail: this.userEmail,
            tk: responseAccess.data.zoomRegistrantToken,
            // zak: this.zakToken,
            success: async (success: any) => {
              ZoomMtg.inMeetingServiceListener('onMeetingStatus', (data: any) => {
                const estado = data.meetingStatus;
                if (estado === 3 || estado === 4) {
                  console.log('La reunión ha terminado o se está cerrando');
                  this.sendFinishPing();
                  this.stopCurrentPing();
                  // Redirige o actualiza tu UI aquí
                }
              });
              await this.sendStartedPing()
              this.startCurrentPing()
              console.log('INICIO', success)
            },
            error: (error: any) => {
              console.log(error)
            }
          })
        },
        error: (error: any) => {
          console.log(error)
        }
      })
    })
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe(params => {
    //   this.evento = params['evento'];
    //   console.log(this.evento);
    // });

    const evento$ = this.route.queryParamMap.pipe(
      map(params => params.get('slug')),
      filter(evento => !!evento)
    );

    combineLatest([evento$, this.viewInit$])
      .subscribe(([evento]) => {
        this.cargarVista(evento as string);
    });


  }

  async decodeToken() {
    const cookie = document.cookie.match(new RegExp('(^| )' + 'cuentame_token' + '=([^;]+)'));
    // const token = localStorage.getItem('id_token');
    // console.log(token)
    const token = cookie ? cookie[2] : null;
    console.log(token)

    const payload = token!.split('.')[1]; // segunda parte del JWT
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/')); // decodifica Base64
    const data = JSON.parse(decoded)
    this.userName = data.firstName;
    this.userEmail = data.email;
    // return JSON.parse(decoded); // convierte a objeto
  }

  async sendStartedPing(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewStart',
      properties: { 
        liveEventViewUuid: this.viewUid,
      }
    }))
  }

  async sendStartedNew(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewNew',
      properties: { 
        liveEventViewUuid: this.viewUid,
        siteVisitUuid: this.stats.siteVisitUuid,
        liveEventSessionId: this.eventData.nextSession.idLiveEventSession,
        liveEventId: this.eventData.nextSession.liveEventId,
      }
    }))
  }

  async sendFinishPing(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewFinish',
      properties: { 
        liveEventViewUuid: this.viewUid,
      }
    }))
  }

  async startCurrentPing(){
    this.pingIntervalId = setInterval(async() => {
      await lastValueFrom(this.stats.sendAnalyticsEvent({
        eventType: 'liveEventViewPing',
        properties: { 
          liveEventViewUuid: this.viewUid,
        }
      }))
      await this.sendData()
    }, 20000);
  }

  stopCurrentPing(){
    if (this.pingIntervalId) {
      console.log('DESACTIVADO')
      clearInterval(this.pingIntervalId);
      this.pingIntervalId = null;
    }
  }

  ngOnDestroy(): void {
    const zoomRoot = document.getElementById('zoom-root');
    if (zoomRoot) {
      zoomRoot.innerHTML = '';
      zoomRoot.removeAttribute('style'); // elimina estilos inline
    }

    // También puedes resetear el body si Zoom lo modificó
    document.body.style.backgroundColor = '';
  }

  sendData(){
    const siteVisitUuid = this.stats.siteVisitUuid;
    const siteVisitTimestamp = this.stats.timestamp;

    console.log('sitevisit', siteVisitUuid)
    console.log('sitevisit', siteVisitTimestamp)
    if (!siteVisitUuid || !siteVisitTimestamp) return;

    this.siteVisitCookie.setSiteVisit(siteVisitUuid, siteVisitTimestamp);
  }
}
